export default __webpack_public_path__ + "static/media/logo.3c31f872.jpg";